import { ApolloClient, from, split, InMemoryCache } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { authLink } from './authLink';
import { errorLink } from './errorLink';
import { httpLink } from './httpLink';
import { tokenStorage } from './types';

export { resetRefreshState } from './tokenRefresh';
export type { AuthFailureConfig } from './types';

const API_BASE = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:4000';
const WS_URL = `${API_BASE.replace(/^http/, 'ws')}/graphql`;

const wsLink = new GraphQLWsLink(
  createClient({
    url: WS_URL,
    connectionParams: () => {
      const token = tokenStorage.getAccessToken();
      return token ? { token } : {};
    },
    // Reconnect on connection loss
    retryAttempts: 5,
    shouldRetry: () => true,
  }),
);

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  from([errorLink, authLink, httpLink]),
);

export const apolloClient = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
    },
  },
});

export async function resetApolloStore(): Promise<void> {
  await apolloClient.resetStore();
}
